import { Component } from '@angular/core';

import { MarkerInfoState } from '../../shared/marker-info.state';

@Component({
  selector: 'app-aggregated-marker',
  templateUrl: './aggregated-marker.component.html',
  styleUrls: ['./aggregated-marker.component.scss'],
})
export class AggregatedMarkerComponent extends MarkerInfoState {}
